export default [
  {
    title: 'Name',
    dataIndex: 'org_name_to_display',
    width: 200,
    ellipsis: true,
  },
  {
    title: 'Logo',
    dataIndex: 'logo',
    width: 80,
  },
  {
    title: 'Address',
    dataIndex: 'Address',
    width: 180,
    ellipsis: true,
  },
  {
    title: 'No Of Employees',
    dataIndex: 'Number_of_emp',
    width: 130,
  },
  {
    title: 'Description',
    dataIndex: 'Description',
    width: 200,
    ellipsis: true,
  },
  {
    title: 'Cap FPS',
    dataIndex: 'fps_cap',
    width: 100,
  },
  {
    title: 'Proxy Server',
    dataIndex: 'use_proxy_server',
    width: 120,
  },
  {
    title: 'Created By',
    dataIndex: 'org_created_by',
    width: 200,
    ellipsis: true,
  },
  {
    title: 'Creation Date (Timezone: UTC)',
    dataIndex: 'org_creation_date',
    width: 220,
  },
  {
    title: 'Kaizen Bucket Created',
    dataIndex: 'kaizen_bucket_created',
    width: 170,
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    width: 100,
  },
];
